import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import BottomContent from 'common/BottomContent';
import ErrorMsg from 'common/ErrorMsg';
import RawHtml from '../common/RawHtml';

import commonStyles from './styles';

const styles = (theme) => {
  const common = commonStyles(theme);

  return {
    ...common,
    fields: {
      ...common.fields,
      '& .field-type--multi-disclosures': {
        borderBottom: `1px solid ${theme.palette.form.border}`,
        paddingBottom: theme.spacing.sm,
      },
    },
  };
};

const EsignDisclosures = ({
  bottomContent,
  children,
  classes,
  hasFields,
  label,
  labelMobile,
  name,
  subText,
}) => (
  <>
    <legend
      className={classnames('grp-label', classes.label)}
      role={!hasFields ? 'presentation' : undefined}
    >
      <RawHtml type="span" className={classnames('desktop', classes.desktopLabel)}>
        {label}
      </RawHtml>
      <RawHtml type="span" className={classnames('mobile', classes.mobileLabel)}>
        {labelMobile}
      </RawHtml>
    </legend>
    <input type="hidden" value="break-autocomplete" />
    <RawHtml className={classnames('content', classes.content)}>{subText}</RawHtml>

    <ErrorMsg name={name} type="group" />

    <div className={classnames('region-fields', classes.fields)}>{children}</div>

    <BottomContent className="bottomContent">{bottomContent}</BottomContent>
  </>
);

EsignDisclosures.propTypes = {
  bottomContent: PropTypes.string,
  children: PropTypes.node.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  hasFields: PropTypes.bool,
  label: PropTypes.string,
  labelMobile: PropTypes.string,
  name: PropTypes.string.isRequired,
  subText: PropTypes.string,
};

EsignDisclosures.defaultProps = {
  bottomContent: '',
  hasFields: false,
  label: '',
  labelMobile: '',
  subText: '',
};

const EsignDisclosuresStyled = withStyles(styles)(EsignDisclosures);

const mapStateToProps = ({ groups }, { name }) => {
  const group = groups[name];
  return {
    bottomContent: group.bottomContent,
    hasFields: group?.fields?.length > 0 ?? false,
    label: group.label,
    labelMobile: group.labelMobile,
    subText: group.subText,
  };
};

export default connect(mapStateToProps)(EsignDisclosuresStyled);
